export default __webpack_public_path__ + "static/media/warning--pass-left-or-right--g3.f01eab62.png";